import { memo } from 'react';

import { Button } from '@air/primitive-button';

import { Routes } from '~/constants/routes';
import { pushWithExistingQuery } from '~/utils/PathUtils';

const handleGoToAllAssets = () => pushWithExistingQuery({ path: Routes.media.all });

export const PrivateSearchAllAssetsButton = memo(() => (
  <Button
    appearance="outline"
    color="blue"
    data-testid="SEARCH_IN_ALL_ASSETS"
    onClick={handleGoToAllAssets}
    size="medium"
  >
    Search all assets
  </Button>
));

PrivateSearchAllAssetsButton.displayName = 'PrivateSearchAllAssetsButton';
